import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ApiPathsService} from "../../api-paths.service";
import {Magazzino} from "../_Models/magazzino";
import { environment } from 'src/environments/environment';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MagazzinoComponent} from "../magazzino/magazzino.component";

@Component({
  selector: 'app-magazzini-list',
  templateUrl: './magazzini-list.component.html'
})
export class MagazziniListComponent implements OnInit {
  @Input() Tipo: string;//route be
  @Input() Object: {Lista: Magazzino[]} = {Lista: []};
  environment= environment;
  constructor(
    private route: ActivatedRoute,
    private apiPaths: ApiPathsService,
    private ngbModal: NgbModal,
  ) { }

  ngOnInit(): void {
    if(!this.Tipo)
      this.route.params.subscribe(data => {
        this.Tipo = data['type'];
        this.Refresh();
      });
  }

  Refresh() {
    this.apiPaths.ClassicPost(`/prodotti/${this.Tipo}/list`, {page:0, size: 10}).subscribe(data => {
      this.Object.Lista = data.data;
    });
  }
  ChangeHandler(item: { OnChange: string; Event: any }) {
    switch (item.OnChange ) {
      case 'OnFilesChange' :
        this.Refresh();
        break;
      case 'OnAdd':
        var MagazinoAddModal = this.ngbModal.open(MagazzinoComponent, {
          centered: true,
          backdrop: 'static',
          size: 'xl',
        });
        (<MagazzinoComponent>MagazinoAddModal.componentInstance).IsModal = true;
        (<MagazzinoComponent>MagazinoAddModal.componentInstance).Item = {};
        (<MagazzinoComponent>MagazinoAddModal.componentInstance).Tipo = this.Tipo;
        MagazinoAddModal.result.then((result) => {
          this.Refresh();
        }, (reason) => {
          this.Refresh();
        });
        break;
      case 'OnDelete':
        if(confirm("Sei sicuro di voler eliminare questo elemento?")) {
          this.apiPaths.ClassicPost(`/prodotti/${this.Tipo}/delete`, {id: item.Event.id}).subscribe(data => {
            this.Refresh();
          });
        }
        break;
      case 'OnEdit':
        var MagazinoEditModal = this.ngbModal.open(MagazzinoComponent, {
          centered: true,
          backdrop: 'static',
          size: 'xl',
        });
        (<MagazzinoComponent>MagazinoEditModal.componentInstance).IsModal = true;
        (<MagazzinoComponent>MagazinoEditModal.componentInstance).Item = {id: item.Event.id};
        (<MagazzinoComponent>MagazinoEditModal.componentInstance).Tipo = this.Tipo;
        MagazinoEditModal.result.then((result) => {
          this.Refresh();
        }, (reason) => {
          this.Refresh();
        });
        break;
    }
  }
}
